<template>
    <div style="padding:20px">
        <vxe-form>
            <vxe-form-item>
                <template #default>
                    <vxe-button status="primary"  icon="vxe-icon--plus"  @click="addOrEditEvent()">添加</vxe-button>
                </template>
            </vxe-form-item>
        </vxe-form>
        <vxe-table
                :data="table.tableData"
                :loading="table.loading"
                empty-text="没有更多数据了！"
        >
            <vxe-table-column type="seq" width="60" title="序号">
            </vxe-table-column>
            <vxe-table-column
                    width="300"
                    field="deptName"
                    title="科室"
            ></vxe-table-column>
            <vxe-table-column
                    field="username"
                    title="账号"
            ></vxe-table-column>
            <vxe-table-column
                    width="160"
                    field="createTime"
                    title="创建时间"
            ></vxe-table-column>
            <vxe-column title="操作" width="200">
                <template #default="{ row }">
                    <vxe-button
                            type="text"
                            icon="vxe-icon--edit-outline"
                            @click="addOrEditEvent(row)"
                    >编辑</vxe-button
                    >
                    <vxe-button
                            type="text"
                            icon="vxe-icon--remove"
                            @click="delEvent(row)"
                    >删除</vxe-button
                    >
                </template>
            </vxe-column>
        </vxe-table>
        <!-- 分页 -->
        <vxe-pager
                background
                v-model:current-page="page.currentPage"
                v-model:page-size="page.pageSize"
                @page-change="pageChange"
                :total="page.totalResult"
                :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
        >
        </vxe-pager>
        <vxe-modal
                v-model="visible"
                :title="form.id?'编辑':'添加'"
                id="formId"
                width="400"
                resize
        >
            <vxe-form
                    :data="form"
                    :rules="formRules"
                    title-align="right"
                    title-width="120"
                    ref="formRef"
            >

                <vxe-form-item
                        title="科室"
                        field="deptName"
                        span="24"
                        :item-render="{}"
                >
                    <template #default="{ data }">
                        <vxe-input
                                v-model="data.deptName"
                                placeholder="请输入科室名称"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                        title="用户名"
                        field="username"
                        span="24"
                        :item-render="{}"
                >
                    <template #default="{ data }">
                        <vxe-input :disabled="!!data.id"
                                v-model="data.username"
                                placeholder="请输入新用户名"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item
                        title="密码"
                        field="passWord"
                        span="24"
                        :item-render="{}"
                >
                    <template #default="{ data }">
                        <vxe-input
                                v-model="data.passWord"
                                type="password"
                                placeholder="默认密码:用户名@123456"
                        ></vxe-input>
                    </template>
                </vxe-form-item>
                <vxe-form-item align="center" span="24" :item-render="{}">
                    <template #default>
                        <vxe-button status="primary" @click="submitForm">提交</vxe-button>
                    </template>
                </vxe-form-item>
            </vxe-form>
        </vxe-modal>
    </div>
</template>

<script>
    import {pageList,save,update} from "@/api/subuser"
    import { checkUserName } from "@/api/login/index";
    import VXETable from "vxe-table";
    import { ElMessageBox } from 'element-plus'
    export default {
        name: "index",
        data(){
            let validateUsername = async ({ itemValue }) => {
                    let res = await checkUserName(itemValue);
                    if(!!res.data) {
                        return new Error("用户名已经被占用");
                    }
            };
            return {
                table:{
                    tableData:[],
                    loading:true
                },
                page:{
                    currentPage:1,
                    pageSize:10,
                    totalResult:0
                },
                visible:false,
                form:{},
                formRules:{
                    username: [
                        { required: true, message: "请输入用户名", trigger: "blur" },
                        { validator: validateUsername }
                    ],
                    deptName: [{ required: true, message: "请输入科室名称", trigger: "blur" }],
                }
            }
        },
        created(){
            this.getTableData();
        },
        methods:{
            getTableData(){
                this.table.loading = true;
                pageList({
                    size: this.page.pageSize,
                    current: this.page.currentPage
                }).then((res) => {
                    this.table.tableData = res.data.records;
                    this.page.totalResult = res.data.total;
                    this.table.loading = false;
                });
            },
            pageChange(){
                this.getTableData();
            },
            addOrEditEvent(row){
                 this.form = row || {};
                 this.visible = true;
            },
            delEvent(row){
                let that = this;
                ElMessageBox({
                    title:'提示',
                    message:'您将删除此用户（'+row.username+'），是否继续？',
                    type:'info',
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(action => {
                    if (action === 'confirm') {
                        row['delFlag'] = '0';
                        update(row).then((res)=>{
                            if(res.code === 0){
                                that.getTableData();
                                that.visible = false;
                            }else{
                                VXETable.modal.message({ content: res.msg, status: "info" });
                            }
                        })
                    }
                });
            },
            submitForm(){
                let that = this
                this.$refs["formRef"].validate((valid) => {
                    if (!valid ||  Object.keys(valid).length === 0) {
                        let handle = that.form.id ? update:save;
                        handle(that.form).then((res)=>{
                            if(res.code === 0){
                                that.getTableData();
                                that.visible = false;
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
